module.exports = __webpack_public_path__ + "static/media/logo-mark.ce690871.svg";